import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { blastKeys } from './queryKeys';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
import markUrl from './markUrl';
const useBlastStats = (blastId, status) => {
    const additional = useQueryRequestParams();
    return useQuery({
        queryKey: blastKeys.stats(blastId, status),
        queryFn: () => axios.get(markUrl('blasts/stats/'), {
            ...additional,
            params: { blast_id: blastId }
        }),
        enabled: !!blastId,
        refetchInterval: status === 'SENDING' || status === 'CANCELLING' ? 15_000 : false
    });
};
export default useBlastStats;
